import { render } from "./bidangSarpras.vue?vue&type=template&id=a0de0886"
import script from "./bidangSarpras.vue?vue&type=script&lang=js"
export * from "./bidangSarpras.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__